<template>
  <div class="bg-yellow-600 min-h-screen">
    <coming-soon></coming-soon>
  </div>
</template>

<script>
// @ is an alias to /src
import ComingSoon from "@/components/ComingSoon.vue";

export default {
  name: "Home",
  components: {
    ComingSoon
  }
};
</script>
